import styles from './Background.module.scss'

const Background = () => {

	return (
		<div className={styles.mainBox}>



		</div>
	)

}

export default Background